import { convertBaseModelToHTML } from "components/Editor/core";
import { wrapSelectionInSpan } from "./color-picker.helper";

export class PickerColorCommand {
  constructor(editor) {
    this.editor = editor;
  }

  execute(color) {
    if (!color) return;

    const selection = this.editor.selection;
    const range = selection.getRange();
    const baseModel = selection.getModelSelection(window.getSelection());
    const doc = this.editor.history.current.doc

    if (!range || !range.native) {
      return;
    }

    // Check if there's selected text
    const hasSelection = range.native.toString().length > 0;

    if (hasSelection) {
      // Save cursor position before applying color
      const savedSelection = selection.save();

      // Apply color using span wrapper to update BaseModel
      const newDoc = wrapSelectionInSpan({ color, baseModel, doc });

      // Render updated BaseModel to HTML
      const innerHTML = convertBaseModelToHTML({ doc: newDoc })
      this.editor.root.innerHTML = innerHTML

      // Restore cursor position
      if (savedSelection) {
        this.editor.selection.restore(savedSelection);
      }

      // Trigger input event to notify editor of changes
      const event = new Event("input", { bubbles: true, cancelable: true });
      this.editor.root.dispatchEvent(event);

      // Trigger selectionchange event to update toolbar with new color
      setTimeout(() => {
        document.dispatchEvent(new Event("selectionchange"));
      }, 0);

      // Take snapshot AFTER DOM is updated to push to history
      this.editor.history?.takeSnapshot();
    } else {
      const nativeRange = range.native;
      const span = document.createElement("span");
      span.style.color = color;
      span.textContent = "\u200B";
      nativeRange.deleteContents();
      nativeRange.insertNode(span);

      // Move cursor after the span so user can type with color
      nativeRange.setStartAfter(span);
      nativeRange.setEndAfter(span);
      const windowSelection = window.getSelection();
      windowSelection?.removeAllRanges();
      windowSelection?.addRange(nativeRange);

      // Focus the editor
      this.editor.root.focus();

      // Trigger input event to notify editor of changes
      const event = new Event("input", { bubbles: true, cancelable: true });
      this.editor.root.dispatchEvent(event);

      // Trigger selectionchange event to update toolbar
      document.dispatchEvent(new Event("selectionchange"));

      // Take snapshot AFTER DOM is updated
      this.editor.history?.takeSnapshot();
    }
  }
}
